export enum AnalyticEvents {
  VIEWED = "Viewed",
  VIEWABLE = "Viewable",
  CLICKED_THROUGH = "Clicked-through",
  ERROR = "Error",
  INTERACTED = "Interacted"
}

export interface Pixels {
  impression: string;
  clickThrough: string;
}

export interface AnalyticsContext {
  viewID: string;
  emit: boolean;
  pixels: Pixels;
  statsURL: string;
  catalogueID: string;
  pageUrl: string;
  operator?: string;
  customField: CustomField;
  adtagID: string;
  campaignID?: string;
  brandID: string;
  externalID?: string;
  campaignVariantIndex?: string;
  offerDisplayedAsFallback: boolean;
  defaultOfferDisplayedAsFirstCard: boolean;
}

export interface AnalyticsBet {
  betOptionID?: string;
  betID: string;
}

export interface CustomField {
  customField1?: string | null;
  customField2?: string | null;
  customField3?: string | null;
  customField4?: string | null;
  customField5?: string | null;
}

export interface AnalyticsRequest {
  adtagID: string;
  brandID: string;
  campaignID?: string;
  bets: AnalyticsBet[];
  viewID: string;
  externalID?: string;
  version: string;
  operator: string;
  statsEventName: string;
  statsEventDescription: string;
  adScreenHeight: number;
  adScreenWidth: number;
  catalogueID: string;
  stakeCurrency?: string;
  stakeAmount?: number;
  pageUrl: string;
  campaignVariantIndex?: string;
  customField1?: string;
  customField2?: string;
  customField3?: string;
  customField4?: string;
  customField5?: string;
  offerDisplayedAsFallback: boolean;
  defaultOfferDisplayedAsFirstCard: boolean;
  prerollDisplayed: boolean;
  prerollName?: string;
}
